/* eslint-disable no-underscore-dangle */
/* eslint-disable no-shadow */
import React from 'react';
import styled from 'styled-components';
import { Column } from 'rbx';

// import SearchItems from './SearchItems';
import TableRows from './TableRows';
import CategoryRow from './CategoryRow';

const Container = styled.div`
  /* -moz-box-shadow: 0px 0px 7px rgba(0, 0, 0, 0.15);
  -webkit-box-shadow: 0px 0px 7px rgba(0, 0, 0, 0.15);
  box-shadow: 0px 0px 7px rgba(0, 0, 0, 0.15); */
  border-radius: 6px;
  margin-bottom: 1rem;
  padding: 0.75rem 1rem;
  border: 1.5px solid #f2f2f2;
  &&& {
    .button {
      border-width: 0;
    }
  }
`;

const Header = styled.div``;

const CategoryDealDiscount = ({
  links,
  selectedCategories,
  setLinks,
  setFieldValue,
  linksForCategoryIsDirty,
}) => (
  <Container>
    <Header>
      <Column.Group>
        <Column size="4">Selected Categories:</Column>
        <Column size="4" />
      </Column.Group>
      <Column.Group style={{ fontWeight: '600', fontSize: '13px' }}>
        <Column size={2}>&nbsp;&nbsp;</Column>
        <Column size={2}>Category</Column>
        <Column size={10}>
          <Column.Group>
            <Column size={2}>Discount Type</Column>
            <Column size={2}>Discount Value</Column>
            <Column size={2}>&nbsp;&nbsp;</Column>
            <Column size={2}>&nbsp;&nbsp;</Column>
            <Column size={2}>&nbsp;&nbsp;</Column>
          </Column.Group>
        </Column>
      </Column.Group>
    </Header>
    {Array.isArray(selectedCategories) &&
      selectedCategories.map(ele => {
        const { category_name: categoryName } = ele;

        const link = links.find(
          ele2 => ele2.menu_section_name === categoryName,
        );

        const filteredLinkIds = links
          .filter(ele2 => ele2.menu_section_name === categoryName)
          .map(ele => ele.item_link_id);

        let initialDiscountType;
        let initialDiscountValue;

        try {
          if (
            link &&
            link.variant &&
            Array.isArray(link.variant) &&
            link.variant.length !== 0
          ) {
            initialDiscountType = link.variant[0].variants[0].type;
            initialDiscountValue = link.variant[0].variants[0].value;
          } else {
            initialDiscountType = link.type;
            initialDiscountValue = link.value;
          }
        } catch {
          // pass
        }

        return (
          <>
            <CategoryRow
              categoryName={categoryName}
              initialDiscountType={initialDiscountType}
              initialDiscountValue={initialDiscountValue}
              links={links}
              setLinks={setLinks}
              setFieldValue={setFieldValue}
              onRemoveItem={() => {
                const temp = selectedCategories.filter(
                  ele2 => ele2.category_id !== ele.category_id,
                );
                setFieldValue('selectedCategories', temp);
              }}
            >
              <Column.Group
                style={{
                  fontSize: '10px',
                  fontWeight: 500,
                  color: '#a8a8a8',
                  marginBottom: '12px',
                }}
              >
                <Column size={2}>Item Name</Column>
                <Column size={10}>
                  <Column.Group>
                    <Column size={2}>Original Price</Column>
                    <Column size={2}>Discount Type</Column>
                    <Column size={2}>Discount Value</Column>
                    <Column size={2}>New Price</Column>
                    <Column size={2}>Savings</Column>
                    <Column size={2}>&nbsp;&nbsp;</Column>
                  </Column.Group>
                </Column>
              </Column.Group>
              {links.length !== 0 &&
                filteredLinkIds.length !== 0 &&
                filteredLinkIds.map(item_link_id => (
                  <TableRows
                    linksForCategoryIsDirty={linksForCategoryIsDirty}
                    key={item_link_id}
                    item_link_id={item_link_id}
                    links={links}
                  />
                ))}
            </CategoryRow>
          </>
        );
      })}
  </Container>
);

export default CategoryDealDiscount;
